import GroupPage from '.';

export const Group = () => <GroupPage />;
